import React, { Component } from 'react';
import { Row, Col, Form, Input, Select } from 'antd';
import { UserPhoto } from "../../common/userPhoto/userPhoto";
import displayServerErrors from '../../../utilities/form/display_server_errors';

const FormItem = Form.Item;
const { TextArea } = Input;
export const revivalPhases = [
  { text: 'Non-event mode', value: 'after_revival' },
  { text: 'Before Event', value: 'before_revival' },
  { text: 'Event Preparation', value: 'revival_preparation' },
  { text: 'Event Backwards(N day before revival start)', value: 'revival_backwards' },
  { text: 'Event', value: 'revival' }
];

export default class UploadScriptureForm extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, passwordType: 'password', dayRequired: false };
  }

  async submitData() {
    try {
      this.setState({ loading: true });
      const {data} = await this.props.mutate(this.props.mutationParams());
      this.props.redirectTo(data);
    } catch(response) {
      displayServerErrors(this.props.form, response);
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit(event) {
    event.preventDefault();

    this.props.form.validateFields((error, _values) => {
      if (!error) {
        this.submitData();
      }
    });
  }

  setDayRequired(newValue) {
    this.setState({ dayRequired: ['revival_preparation', 'revival_backwards', 'revival'].includes(newValue) },
      () => this.props.form.validateFields(['day'], { force: true }))
  }

  getDailyScriptureField(name) {
    return this.props.dailyScripture ? this.props.dailyScripture[name] : undefined;
  }

  onPhotoLoad = (photoDataUri) => {
    this.props.form.setFieldsValue({ image_data_uri: photoDataUri });
  };

  onPhotoRemove = () => {
    this.props.form.setFieldsValue({ image_data_uri: this.props.dailyScripture.image.default });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <Form onSubmit={this.onSubmit.bind(this)} className="login-form">
            <h1 className="login-form__header">Welcome to SOW Evangelism Pastor page!</h1>
            <Row type="flex">
              <Col xs={{ span: 24 }} md={{ span: 16 }} xl={{ span: 20 }} className="daily-scriptures-list__inputs-col">
                <FormItem>
                  {getFieldDecorator('type', {
                    initialValue: this.getDailyScriptureField('typeValue') || 'after_revival',
                    rules: [
                      { required: true, message: 'Please select type' }
                    ],
                  })(
                    <Select placeholder="Event phase" onChange={this.setDayRequired.bind(this)}>
                      {
                        revivalPhases.map((phase, index) => {
                          return <Select.Option key={index} value={phase.value}>{phase.text}</Select.Option>;
                        })
                      }
                    </Select>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('day', {
                    initialValue: this.getDailyScriptureField('day'),
                    rules: [
                      { required: this.state.dayRequired, message: 'Please input day number'}
                    ]
                  })(
                    <Input placeholder="Event day" type="number" />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('headline', {
                    initialValue: this.getDailyScriptureField('headline'),
                    rules: [
                      { required: true, message: 'Please input scripture headline' }
                    ],
                  })(
                    <Input placeholder="Headline" />
                  )}
                </FormItem>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 7, offset: 1 }} xl={{ span: 3, offset: 1 }} className="daily-scriptures-list__inputs-col">
                <FormItem>
                  {getFieldDecorator('image_data_uri', {
                    initialValue: '',
                    rules: [
                      { required: !this.props.dailyScripture, message: 'Please input scripture image' }
                    ],
                  })(
                    <UserPhoto photoURL={this.props.dailyScripture && this.props.dailyScripture.image.default}
                               onPhotoLoad={this.onPhotoLoad}
                               hideRemoveButton/>
                  )}
                </FormItem>
              </Col>
            </Row>
            <FormItem>
              {getFieldDecorator('text', {
                initialValue: this.getDailyScriptureField('text'),
                rules: [
                  { required: true, message: 'Please input scripture text' }
                ],
              })(
                <TextArea placeholder="Text" rows={10} />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('comment', {
                initialValue: this.getDailyScriptureField('comment'),
                rules: [
                  { required: true, message: 'Please input scripture comment' }
                ],
              })(
                <TextArea placeholder="Text" rows={4} />
              )}
            </FormItem>

            <FormItem>
              { this.props.formControls(this.state.loading) }
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/dailyScripturesForm.js